import React from "react";
import "../About/AcademicSection.css";

const AcademicSection = () => {
  return (
    <div id="academic-section" className="">
      <div className="academic-text-container">
        <div className="academic-photo">
        </div>
        <div className="text">
          <span>
            Iniciei a formação em Psicologia, como um ato estratégico que contribui para
            minha atuação nas políticas públicas de cuidado, seguridade e saúde. Minha busca
            por esse caminho se deu pelo desejo de ampliar minha participação na construção
            de políticas e dispositivos que efetivamente respondam ao sofrimento psíquico em
            sua complexidade, interesse que desenvolvi ao longo da minha jornada no SUS e
            das formações complementares em cordenação de grupos operativos, gestão em saúde
            e gestão de políticas públicas.<br></br>
            A Especialização em Psicopatologia, Psicanálise
            e Clínica Contemporânea, iniciada em 2023, veio como parte desse contínuo
            encontro entre teoria e prática. Um aprofundamento que considero importante para
            meu olhar clínico e teórico diante das complexidades da clínica atual, e da
            compreensão sobre as dinâmicas do sofrimento psíquico.
          </span>
        </div>
      </div>
    </div>
  );
}

export default AcademicSection;
